import { useEffect, useState } from "react";
import dayjs from "dayjs";
import Table from "../../Reusable/Table/Table1";
import {
  UserOutlined,
  EyeOutlined,
  WalletOutlined,
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  StopOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
  CopyOutlined,
} from "@ant-design/icons";
import DropdownButton from "../../Reusable/dropdown/Drop";
import ReusableModal from "../../Reusable/Model/Model";
import ReusableDrawer from "../../Reusable/Drawer/Drawer";
import EditableTable from "../../Reusable/Table/EditableTable";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Tag,
  message,
  Input,
  Badge,
  Button,
  Form,
  Select,
  Image,
  Segmented,
  DatePicker,
} from "antd";
import consts from "../../constant";
import Loadingpage from "../Loadingpage/Loadingpage";
const { RangePicker } = DatePicker;
const Updown = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [openBlock, setOpenBlock] = useState(false);
  const [openBlock2, setOpenBlock2] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [formLayout] = useState("vertical");
  const [form] = Form.useForm();
  const [page, setPage] = useState({ current: 1, pageSize: 10 });
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openViewDrawer, setOpenViewDrawer] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("false");
  const [messageApi, contextHolder] = message.useMessage();
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [status, setStatus] = useState(false);
  const [block, setBlock] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState(
    "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
  );

  const [wallet, setWallet] = useState([]);
  const [dateRange, setDateRange] = useState([]);
  const [statusFilter, setStatusFilter] = useState(undefined);
  const [directionFilter, setDirectionFilter] = useState(undefined);
  const [searchVal, setSearchVal] = useState("");

  const { Search } = Input;




  const onClose = () => {
    setOpenDrawer(false);
    setSelectedUser(null);
    setOpenViewDrawer(false);
  };

  const userColumns = [
    { title: "Sno", dataIndex: "sno", key: "sno" },
    {
      title: "User",
      dataIndex: "user",
      key: "user",
      render: (_, record) => (
        <div>
          <div>{record.name}</div>
          <div style={{ fontSize: "10px", color: "gray" }}>{record.email}</div>
        </div>
      ),
    },
    {
      title: "Pair",
      dataIndex: "pair",
      key: "pair",
    },
    {
      title: "Round ID",
      dataIndex: "roundId",
      key: "roundId",
    },
    {
      title: "Direction",
      dataIndex: "direction",
      key: "direction",
      render: (text) => (
        <Tag color={text?.toLowerCase() === "up" ? "green" : "red"}>
          {text?.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Multiplier",
      dataIndex: "payoutMultiplier",
      key: "payoutMultiplier",
    },
    {
      title: "Profit",
      dataIndex: "profit",
      key: "Profit",
    },
    {
      title: "End Time",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => {
        let color = "blue";
        if (text === "WON") color = "green";
        if (text === "LOST") color = "red";
        if (text === "CANCELLED") color = "orange";
        return <Tag color={color}>{text?.toUpperCase()}</Tag>;
      },
    },
  ];

  const handlePagination = (pagination) => {
    setPage(pagination);
  };

  const getHistory = async (value) => {
    try {
      setConfirmLoading(true);
      const { data } = await axios.post(
        `${consts.BackendUrl}/get-sportsdey-trade-history`,
        {
          type: "up_down",
          search: value || searchVal,
          status: statusFilter,
          direction: directionFilter,
          start: dateRange?.[0] ? dateRange[0].format("YYYY-MM-DD") : undefined,
          end: dateRange?.[1] ? dateRange[1].format("YYYY-MM-DD") : undefined,
        },
        {
          params: {
            page: page?.current || 1,
            limit: page?.pageSize || 10,
          },
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        },
      );

      if (data?.success === true && data?.result?.length > 0) {
        setTotal(data?.total);
        const mappedData = data.result.map((item, index) => ({
          key: item._id,
          sno: page?.current
            ? (page?.current - 1) * page?.pageSize + index + 1
            : index + 1,
          name: item.userId?.name || "-",
          email: item.userId?.email || "-",
          pair: item.pair || "-",
          roundId: item.roundId || "-",
          direction: item.direction || "-",
          amount: item.amount || "-",
          payoutMultiplier: item.payoutMultiplier || "-",
          profit: item.profitAmount || "-",
          date: new Date(item.createdAt).toLocaleString(),
          status: item.status || "-",
        }));

        setUsers(mappedData);
        setConfirmLoading(false);
      } else {
        setUsers([]);
        setTotal(0);
        setConfirmLoading(false);
      }
    } catch (error) {
      console.log(error?.response?.data?.message);
      setUsers([]);
      setTotal(0);
      setConfirmLoading(false);
    }
  };


  const onFinish = async (values) => {
    try {
      if (values?.balance <= 0) {
        return messageApi.open({
          type: "error",
          content: "Wallet balance should be greater than 0",
        });
      }
      console.log(selectedUser?.status, values?.status, "oudijdjd");
      if (
        selectedUser?.status != (values?.status === "Active" ? "true" : "false")
      ) {
        const response = await axios.patch(
          `${consts.BackendUrl}/users/update/${selectedUser?.key}`,
          {
            id: selectedUser?.key,
            status: values?.status === "Active" ? "true" : "false",
          },
          {
            headers: {
              Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
            },
          },
        );
      }
      const response = await axios.post(
        `${consts.BackendUrl}/updateUserWallet`,
        {
          userid: selectedUser?.key,
          walletBalance: values?.balance,
        },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        },
      );

      if (response?.data?.success) {
        messageApi.open({
          type: "success",
          content: "Updated successfully",
        });
        getHistory();
        setOpenViewDrawer(false);
      } else {
        messageApi.open({
          type: "error",
          content: "Failed to update",
        });
      }
    } catch (error) {
      console.log(error);
      messageApi.open({
        type: "error",
        content: error?.response?.data?.message || "Failed to update wallet",
      });
    }
  };

  const onChange = async (e) => {
    const filterWalletByType = wallet?.filter((item) => {
      return e === item?.type;
    });

    form.setFieldsValue({
      type: e,
      balance: filterWalletByType?.[0]?.balance || 0,
    });
  };


  const clearFilters = () => {
    setStatusFilter(undefined);
    setDirectionFilter(undefined);
    setDateRange([]);
    setSearchVal("");
    setPage((prev) => ({ ...prev, current: 1 }));
    getHistory("");
  };

  const onDateChange = (dates) => {
    setDateRange(dates || []);
    setPage((prev) => ({ ...prev, current: 1 }));
  };

  useEffect(() => {
    getHistory();
  }, [page, dateRange, statusFilter, directionFilter]);

  return (
    <>
      <Loadingpage />
      <div
        className="display-2 p-10"
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <h2>Up-Down History</h2>
        <div className="display-1">
          <Search
            placeholder="Search name, email or pair"
            value={searchVal}
            onChange={(e) => setSearchVal(e.target.value)}
            onSearch={(e) => {
              setPage((prev) => ({ ...prev, current: 1 }));
              getHistory(e);
            }}
            allowClear
            style={{ width: 250 }}
            loading={confirmLoading}
            className="input-cls"
          />
          <Select
            placeholder="Status"
            value={statusFilter}
            style={{ width: 120 }}
            allowClear
            onChange={(val) => setStatusFilter(val)}
            options={[
              { value: "REFUNDED", label: "Refunded" },
              { value: "WON", label: "Won" },
              { value: "LOST", label: "Lost" },
            ]}
          />
          <Select
            placeholder="Direction"
            value={directionFilter}
            style={{ width: 120 }}
            allowClear
            onChange={(val) => setDirectionFilter(val)}
            options={[
              { value: "UP", label: "Up" },
              { value: "DOWN", label: "Down" },
            ]}
          />
          <RangePicker
            className="input-cls"
            value={dateRange}
            onChange={onDateChange}
          />
          <Button onClick={clearFilters}>Clear</Button>
        </div>
      </div>
      <EditableTable
        columnsConfig={userColumns}
        dataSource={users}
        className="mt-20"
        total={total}
        pageSize={10}
        current={page?.current ? page?.current : 1}
        closeDisabled={true}
        onChange={handlePagination}
      />

      <ReusableDrawer
        open={openViewDrawer}
        onClose={onClose}
        title="View"
        extra={<CloseCircleOutlined className="cursor" onClick={onClose} />}
      >
        <Form
          layout={formLayout}
          form={form}
          onFinish={onFinish}
          style={{ maxWidth: 600 }}
        >
          <Form.Item label="Username" name="username">
            <Input style={{ width: "100%" }} type="text" readOnly />
          </Form.Item>
          <Form.Item
            label="Type"
            name="type"
            rules={[{ required: true, message: "Please select type" }]}
          >
            <Select placeholder="Select type" name="type" onChange={onChange}>
              {/* <Select.Option value="Crypto">Crypto</Select.Option>
              <Select.Option value="Stablecoin">Stablecoin</Select.Option>
              <Select.Option value="Token">Token</Select.Option>
              <Select.Option value="NFT">NFT</Select.Option> */}
              <Select.Option value="USD">USD</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item label="Balance" name="balance">
            <Input style={{ width: "100%" }} type="number" />
          </Form.Item>
          <Form.Item name="status" label="Status">
            <Segmented options={["Active", "In-Active"]} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Update
            </Button>
          </Form.Item>
        </Form>
      </ReusableDrawer>
      {contextHolder}
    </>
  );
};

export default Updown;
